import SingleAddressTile from 'components/SingleAddressTile';
import React, { useState } from 'react';
import styles from '../index.module.scss';
import _ from 'lodash';
import { deleteAddress } from 'services';
import { showError, showSuccess, stringifyAndParseObj } from 'utils';
import ActionButton from 'components/ActionButton';
import scriptLoader from 'react-async-script-loader';
import AddAddressModal from 'components/UserAddressModal/AddAddressModal';

const UserAddresses = props => {
  const [addressDeleteID, setAddressDeleteID] = useState<string>('');
  const [addressToEdit, setAddressToEdit] = useState();
  const [addressModalOpen, setAddressModalOpen] = useState<boolean>(false);
  const {
    user,
    addresses,
    refetchAddresses,
  } = props;
  
  const deleteAddressFn = async (id: string) => {
    setAddressDeleteID(id);
    try {
      await deleteAddress(id);
      showSuccess('Address deleted Successfully');
      refetchAddresses();
    } catch (e) {
      showError(e);
    } finally {
      setAddressDeleteID('');
    }
  };
  
  const toggleAddressModal = () => setAddressModalOpen(!addressModalOpen);
  
  const getEmptyAddressSection = () => (
    <div className={styles['empty-address-section']}>No Addresses added</div>
  );
  
  const getSingleAddress = (address: Record<string, any>) => {
    const contactName = _.get(address, 'contactName', '');
    const contactPhone = _.get(address, 'contactPhone', '');
    return (
      <SingleAddressTile
        key={address.objectId}
        loading={addressDeleteID === address.objectId}
        contactName={contactName}
        contactPhone={contactPhone}
        addressDetails={address}
        setAddress={address => {}}
        deleteAddressFn={deleteAddressFn}
        toggleAddressModal={toggleAddressModal}
        setAddressToEdit={setAddressToEdit}
        showAddressActions={true}
        showInvalidAddresses={true}
      />
    );
  };
    
  return (
    <div className={styles['saved-addresses-container']}>
      {addressModalOpen && (
        <AddAddressModal
          modalOpen={addressModalOpen}
          address={addressToEdit ? stringifyAndParseObj(addressToEdit) : addressToEdit}
          user={user}
          onSuccess={refetchAddresses}
          onModalClose={toggleAddressModal}
        />
      )}
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Saved Addresses</div>
        <ActionButton
          active={true}
          isLoading={false}
          onClick={()=>{
            toggleAddressModal(); 
            setAddressToEdit(undefined);
          }}
          text={<>Address<span className={'ml-3'}>+</span></>}
        />
      </div>
      {addresses?.length ? (
        <div className={styles['address-container']}>
          {addresses.map((record, i) => getSingleAddress(record))}
        </div>
      ): getEmptyAddressSection()}
    </div>
  );
};

export default scriptLoader(
  [`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&libraries=places`],
)(UserAddresses);